import * as common from './common'
import * as progressGetters from 'js-core/store/getters/progress'

export default {
    ...common,
    ...progressGetters
}